module.exports = __webpack_public_path__ + "img/signature_placeholder.c4aa82e2.png";